<nz-modal
  (nzOnCancel)='closeDrawer()'
  [nzClosable]="true"
  [nzTitle]="drawerTitleTpl"
  [nzVisible]="show"
  (nzOnOk)='saveChanges()'
  [nzOkDisabled]='form.invalid || isSubmitting'
  [nzCancelDisabled]="isSubmitting"
  [nzOkText]="isSubmitting ? 'Saving...' : 'Save Changes'"
  [nzOkLoading]="isSubmitting"
  [nzWidth]="600"
>
  <ng-template #drawerTitleTpl>
    <div class='flex items-center gap-2'>
      <span class='fe fe-edit text-primary'></span>
      <span>Edit Discount Rate</span>
    </div>
  </ng-template>
  
  <div *nzModalContent>
    <app-error-display 
      *ngIf="showError() && errorDetails" 
      [error]="errorDetails" 
      (dismiss)="onDismissError()" 
      (retry)="saveChanges()">
    </app-error-display>
    
    <form [formGroup]="form" nz-form nzLayout="vertical" class='space-y-4'>
      <!-- Name -->
      <nz-form-item>
        <nz-form-label nzRequired class='font-semibold'>Discount Name</nz-form-label>
        <nz-form-control nzErrorTip='Please enter a discount name'>
          <input
            formControlName='name'
            nz-input
            placeholder='e.g., Student Discount, Senior Citizen'
            type='text'
          />
        </nz-form-control>
      </nz-form-item>

      <!-- Description -->
      <nz-form-item>
        <nz-form-label class='font-semibold'>Description</nz-form-label>
        <nz-form-control>
          <textarea
            formControlName='description'
            nz-input
            rows='3'
            placeholder='Optional description for this discount'
          ></textarea>
        </nz-form-control>
      </nz-form-item>

      <!-- Code and Rate Row -->
      <div class='grid grid-cols-2 gap-4'>
        <!-- Code -->
        <nz-form-item>
          <nz-form-label class='font-semibold'>
            Discount Code
            <span class='text-xs text-gray-500 ml-1'>(Optional)</span>
          </nz-form-label>
          <nz-form-control nzErrorTip='Use only uppercase letters, numbers, - and _'>
            <input
              formControlName='code'
              nz-input
              placeholder='e.g., STUDENT10'
              type='text'
              style='text-transform: uppercase;'
              maxlength='20'
            />
          </nz-form-control>
        </nz-form-item>

        <!-- Rate -->
        <nz-form-item>
          <nz-form-label nzRequired class='font-semibold'>Discount Rate (%)</nz-form-label>
          <nz-form-control nzErrorTip='Please enter a valid rate'>
            <nz-input-group nzSuffix='%'>
              <input
                [decimal]='true'
                decimalSeparator='.'
                digitOnly
                formControlName='rate'
                nz-input
                pattern='^\d+(\.\d{1,2})?$'
                placeholder='0.00'
                type='text'
              />
            </nz-input-group>
          </nz-form-control>
        </nz-form-item>
      </div>

      <!-- Applicability -->
      <nz-form-item>
        <nz-form-label class='font-semibold'>Apply Discount To</nz-form-label>
        <nz-form-control>
          <div class='space-y-2'>
            <label nz-checkbox formControlName='applicableToBookings'>
              <span class='ml-2'>Seat Bookings</span>
            </label>
            <br />
            <label nz-checkbox formControlName='applicableToParcels'>
              <span class='ml-2'>Parcel Deliveries</span>
            </label>
          </div>
          <div class='text-xs text-gray-500 mt-2'>
            Select where this discount can be applied (for future integration)
          </div>
        </nz-form-control>
      </nz-form-item>
    </form>
  </div>
</nz-modal>
